import { createSlice } from '@reduxjs/toolkit'

export const teacherSlice = createSlice({
    name: 'teacher',
    initialState: {
        periods: [],
        courses: [],
        scheme: null,
        schemeId: null,
        isLoading: false,
        courseName: null,
        update: null
    },
    reducers: {
        periodsStart: () => {},

        coursesStart: () => {},

        schemeStart: () => {},

        saveSchemeStart: () => {},

        saveChangeStart: () => {},

        generateSchemeStart: () =>  {},

        regenerateSchemeStart: () =>  {},

        schemePDFStart: () =>  {},

        setPeriods: (state, action) => {
            state.periods = action.payload
            return state;
        },

        toggleLoading: (state, action) => {
            const boolean = action.payload
            state.isLoading = boolean
            return state;
        },

        setCourses: (state, action) => {
            state.courses = action.payload
            return state;
        },

        setCourseName: (state, action) => {
            state.courseName = action.payload
            return state;
        },

        setScheme: (state, action) => {
            state.scheme = action.payload
            return state;
        },
        
        setUpdate:  (state, action)=> {
            state.update = action.payload;
            return state;
        },

        setSchemeNode: (state, action) => {
            let newscheme = []
            
            action.payload.oldscheme.forEach(element => {
                if(element.type === "textWithTypes")  {                    
                    let newelement = JSON.parse(JSON.stringify(element));
                    if (newelement.data.audial.text===action.payload.data.oldText)
                    {
                        if(action.payload.data.url === undefined)
                        {
                            newelement.data.audial.text = action.payload.data.scheme.data.text;
                        }
                        else
                        {
                            const images =  [...newelement.data.audial.images, action.payload.data.url] ;
                            newelement.data.audial.images = images;
                        }
                    }
                    else if (element.data.visual.text===action.payload.data.oldText)
                    {
                        if(action.payload.data.url === undefined)
                            newelement.data.visual.text = action.payload.data.scheme.data.text
                        else
                        {
                            const images =  [...element.data.visual.images, action.payload.data.url] ;
                            newelement.data.visual.images = images;
                        }
                    } 
                    else if (element.data.discrete.text===action.payload.data.oldText)
                    {
                        if(action.payload.data.url === undefined)
                            newelement.data.discrete.text = action.payload.data.scheme.data.text
                        else
                        {
                            const images =  [...element.data.discrete.images, action.payload.data.url] ;
                            newelement.data.discrete.images = images;
                        }
                    }
                    else if (element.data.kinesthetic.text===action.payload.data.oldText)
                    {
                        if(action.payload.data.url === undefined)
                            newelement.data.kinesthetic.text = action.payload.data.scheme.data.text
                        else
                        {
                            const images =  [...element.data.kinesthetic.images, action.payload.data.url] ;
                            newelement.data.kinesthetic.images = images;
                        }
                    }


                  newscheme.push(newelement);

                }   
                else if(element.type === "text" && element.data.text===action.payload.data.oldText)  {                    
                    if(action.payload.data.url === undefined)
                    {
                    //    console.log("new text")
                        newscheme.push({...element, data: {...element.data, text: action.payload.data.scheme.data.text}})
                    }
                    else
                    {                     
                        const images =  [...element.data.images, action.payload.data.url]                                                
                        newscheme.push({...element, data: {...element.data, images: images}})
                    }

                }                 
                else {
                    newscheme.push(element)
                }
            });
            
            
            if(newscheme.length>0)
            {                        
                state = { ...state, scheme: {rating: state.scheme.rating, scheme: newscheme }}        
                return state;
            }
            return state;
            
        },
        setSchemeId: (state, action) => {
            state.schemeId = action.payload
            return state;
        }
    },

})

export const teacherActions = teacherSlice.actions

export const teacher = teacherSlice.reducer